<template>
  <form v-on:submit.prevent="saveHold" autocomplete="off">
    <div class="sm:flex sm:items-start">
      <div class="mt-3 text-left w-full">
        <h3
          class="text-lg leading-6 font-medium text-gray-900"
          id="modal-headline"
        >
          Hold Order
        </h3>
        <div class="mt-2">
          <p class="text-sm leading-5 text-gray-500">
            Please enter a reason for putting this order on hold.
          </p>
        </div>
        <div class="mt-2">
          <label for="email" class="sr-only">Reason</label>
          <div class="relative rounded-md shadow-sm">
            <input
              id="reason"
              v-model="form.reason"
              class="form-input block w-full sm:text-sm sm:leading-5"
              placeholder="Reason"
            />
          </div>
        </div>
      </div>
    </div>

    <HttpError :error="error" />

    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <Button
          type="submit"
          :disabled="saving || form.reason == null"
          class="flex items-center space-x-2"
        >
          <span>Save</span>
          <LoadingSpinner v-if="saving" class="text-white" />
        </Button>
      </span>
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <Button
          class="btn btn-white"
          v-on:click-handler="$emit('onClose', true)"
        >
          Cancel
        </Button>
      </span>
    </div>
  </form>
</template>

<script>
import Button from "@/components/elements/Button.vue";
import { ModalBus } from "@/eventBus";

export default {
  props: {},
  data() {
    return {
      saving: false,
      error: null,
      form: {
        reason: null,
      },
    };
  },
  computed: {},
  components: {
    Button,
  },
  methods: {
    saveHold() {
      this.saving = true;
      this.error = null;

      const order = this.$store.getters["orders/getOrder"];

      this.$store
        .dispatch("orders/holdOrder", {
          OrderNumber: order.SourceOrderNumber,
          data: { Note: this.form.reason },
        })
        .then(() => {
          this.$emit("onClose");
          ModalBus.$emit("hold:update:row");
        })
        .catch((e) => (this.error = e))
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
